import React from 'react';
export function ClosingSection() {
  return <section className="w-full border-t border-line bg-night-deep" data-id="element-34" data-mp="1fe71qlomjhxr">
      <div className="mx-auto max-w-3xl px-4 py-10 text-center sm:px-5 sm:py-16" data-id="element-35" data-mp="ou43e9r1yyox">
        <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-gold sm:text-xs sm:tracking-[0.28em]" data-id="element-36" data-mp="12t3stjme3hm5">
          Final thoughts
        </p>
        <h2 className="mt-4 font-display text-[1.75rem] uppercase leading-tight tracking-tight text-cream sm:text-4xl" data-id="element-37" data-mp="xvv5l4mdwne1">
          The clock is <span className="text-gold" data-id="element-38" data-mp="17sgfo4d9gooq">ticking</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-cream-muted sm:text-base" data-id="element-39" data-mp="17pu4lur5vr1r">
          Tomorrow you can go back to hunting for tabs and worksheets… or you can have your entire
          year of guitar material ready in the next 60 seconds.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-cream-muted sm:text-base" data-id="element-40" data-mp="1vhskks1k2al8">
          You’ve spent years mastering the guitar. You deserve a teaching system that matches your
          playing.
        </p>
        <p className="mt-7 font-serif text-lg italic text-cream sm:text-2xl" data-id="element-41" data-mp="27bfh2n01nvgd">
          Stop the Sunday scramble. Start the system.
        </p>
      </div>
    </section>;
}